import { useState, useEffect, useContext, useReducer } from "react";
import { useHistory } from "react-router-dom";

import { useQuestionnaire } from "../../../../Hooks/useQuestionnaire";
import { usePageLoad } from "../../../../Hooks/usePageLoad";
import { useAddressApi } from "../../../../Hooks/useAddressApi";
import { useFollowupUserQuestions } from "../../../../Hooks/useFollowupUserQuestions";
import { getPageName } from "../../../../Constants/PageNames";
import VisitorParamsContext from "../../../../Contexts/VisitorParams";

import diamond from "../../../../assets/UFC_DC_V1/img/diamond.png";
import ssl from "../../../../assets/UFC_DC_V1/img/ssl.png";
import excellent_review from "../../../../assets/UFC_DC_V1/img/excellent-review.svg";
import pound from "../../../../assets/UFC_DC_V1/img/pound.png";
import bg_money_sml from "../../../../assets/UFC_DC_V1/img/bg-money-sml.png";
import logo_white from "../../../../assets/UFC_DC_V1/img/logo-white.png";
import GtmDataLayer from "../../../../Utility/GtmDataLayer";

const initialState = {
  questOne: "hide",
  questTwo: "hide",
  questThree: "hide",
};
console.log("initialState", initialState);
const QuestionnaireReducer = (state, action) => {
  switch (action.type) {
    case "showSlideChange": {
      const updatedState = Object.keys(state).reduce((acc, key) => {
        acc[key] = key === action.payload ? "show" : "hide";
        setTimeout(() => {
          window.scrollTo(0, 0);
        }, 500);
        return acc;
      }, {});
      return { ...state, ...updatedState };
    }
    default:
      return state;
  }
};

const CreditCheckQuestions_FLP_OD = ({
  selectedBank,
  allFollowupData,
  removeFromPending,
  creditPendingSlides,
  uuid,
  userData,
}) => {
  const query = new URLSearchParams(window.location.search);
  const [questOne, setQuestOne] = useState("show");
  const [questTwo, setQuestTwo] = useState("hide");
  const [showRefundSection, setShowRefundSection] = useState("");
  const [btnDisable, setBtnDisable] = useState(true);
  const [questThree, setQuestThree] = useState("hide");
  const [bacKbtnId, setBacKbtnId] = useState("1");
  const [estimatedRefund, setEstimatedRefund] = useState("");
  const [unaffordableRefund, setUnaffordableRefund] = useState("");
  const [question118, SetQuestion118] = useState("");
  const { isLoading, SaveQuestionnaire } = useQuestionnaire();
  const { visitorParameters } = useContext(VisitorParamsContext);
  const formdata = JSON.parse(localStorage.getItem("formData"));
  const query_string = localStorage.getItem("queryString");
  const { savePageLoad, calledOnce } = usePageLoad();
  const splitName = localStorage.getItem("split_name");
  // const uuid = visitorParameters.visitor_parameters.uuid;
  const history = useHistory();
  const { addressCheck } = useAddressApi();
  let nextPage = "questionaireUFC_DC_V3";
  const { saveFollowupUserQuestions } = useFollowupUserQuestions();
  const [state, dispatch] = useReducer(QuestionnaireReducer, initialState);
  const flp_source = allFollowupData.atp_sub6;


  useEffect(() => {
    slideChange(creditPendingSlides);
  }, [creditPendingSlides]);

  useEffect(() => {
    if (!!uuid && !calledOnce) {
      const data = {
        uuid,
        page_name: getPageName("credit_check_question_UFC_DC_V3"),
        status: "visited",
        source: flp_source,
      };
      (async () => {
        await savePageLoad(
          uuid,
          data,
          "visited_status",
          splitName,
          query_string,
          allFollowupData
        );
      })();
    }
  }, [uuid, calledOnce]);

  const removePendingSlides = (slidename) => {
    const index = creditPendingSlides.indexOf(slidename);
    if (index > -1) {
      creditPendingSlides.splice(index, 1);
    }

    slideChange(creditPendingSlides);
  };

  const slideChange = (pendingQuestionSlides) => {
    let pendingCount = pendingQuestionSlides.length;
    if (pendingCount == 0) {
      removeFromPending("creditCheck_Questions");
      return false;
    }
    pendingQuestionSlides?.every((element) => {
      dispatch({ type: "showSlideChange", payload: element });
    });
  };

  const completePageLeadStatus = () => {
    const data = {
      uuid,
      page_name: getPageName("credit_check_question_UFC_DC_V3"),
      status: "completed",
      source: flp_source,
    };
    (async () => {
      await savePageLoad(
        uuid,
        data,
        "visited_status",
        splitName,
        query_string,
        allFollowupData
      );
    })();
  };

  let question_data = {};

  const storeQuestionnire = async (question_data) => {
    const response = await saveFollowupUserQuestions(
      question_data,
      allFollowupData,
      "followup_question_store"
    );
  };
  let flage = false;

  const nextQuestion = (e) => {
    if (e.target.name == "check1") {
      flage = true;
      question_data = {
        question_id: 114,
        option_id: e.target.value,
        answer_text: null,
        input_answer: null,
      };
      if (e.target.value == "319") {
        completePageLeadStatus();
        removePendingSlides("questTwo");
        removePendingSlides("questThree");
        removeFromPending("send_otp_flp");
        removeFromPending("submit_otp_flp");
        removeFromPending("otp_confirmation_page");
      }
      removePendingSlides("questOne");
    }

    if (e.target.name == "check2") {
      flage = true;
      question_data = {
        question_id: 115,
        option_id: e.target.value,
        answer_text: null,
        input_answer: null,
      };
      if (e.target.value == "321") {
        completePageLeadStatus();
        addressCheck({ 'uuid': uuid }, userData);
        removePendingSlides("questThree");
      }
      removePendingSlides("questTwo");
    }

    if (e.target.name == "check3") {
      flage = true;
      question_data = {
        question_id: 118,
        option_id: e.target.value,
        answer_text: null,
        input_answer: null,
      };
      completePageLeadStatus();
      addressCheck({ 'uuid': uuid }, userData);
      removePendingSlides("questThree");
    }

    if (flage) {
      storeQuestionnire(question_data);
      let _existingEntries = JSON.parse(localStorage.getItem("questionData"));
      if (_existingEntries == null) _existingEntries = [];
      let existingIndex = _existingEntries.findIndex(
        (entry) => entry.question_id === question_data.question_id
      );
      if (existingIndex !== -1) {
        _existingEntries.splice(existingIndex, 1);
      }
      _existingEntries.push(question_data);
      localStorage.setItem("questionData", JSON.stringify(_existingEntries));
    }
  };

  const prevQuestion = (e) => {
    const value = Number(e.target.value);
    console.log("value", value);
    setBacKbtnId((prevId) => {
      const newId = Math.max(1, prevId - 1); // Prevents going below 1

      setBtnDisable(newId === 1); // Disable only if backBtnId is 1

      return newId;
    });
    switch (value) {
      case 1:
        setBtnDisable(true);
        setShowRefundSection("");
        setQuestOne("show");
        setQuestTwo("hide");
        break;

      case 2:
        setBacKbtnId(1); // Moving back from 2 to 1
        setQuestTwo("hide");
        setQuestOne("show");
        setBtnDisable(false); // Re-enable button if it was disabled
        break;

      case 3:
        setBacKbtnId(2); // Moving back from 3 to 2
        setQuestTwo("show");
        setQuestThree("hide"); // Assuming you meant "hide" instead of "three"
        break;

      default:
        console.warn("Unexpected value in prevQuestion:", value);
    }
  };

  return (
    <>
      <div className="UFC_DC_V3">
        <section className={`banner  parallax-container `}>
          <div className="d-lg-none d-md-none d-sm-block d-block money-bg-mobile">
            <img src={bg_money_sml} alt="" />
          </div>
          <div className="container">
            <div>
              <div className="brand">
                <div className="logo pt-3">
                  <a href="index.html">
                    {" "}
                    <img src={logo_white} height="60" alt="" />
                  </a>
                </div>
              </div>
            </div>
            <div></div>
          </div>
          <div className="container pt-5 px-lg-2 px-md-2 px-sm-0 px-0  ">
            <div className="inner-section   ">
              <div className="body-questionnaire mb-4">
                <div className="inner rounded-4">
                  <div className="swiper qsSlider slide-up-now">
                    <div className="swiper-wrapper">
                      <div
                        className={`swiper-slide slide-up-now ${state.questOne}`}
                      >
                        <h2 className="qs-title">
                          {`Would you like to run a free, online scan to calculate
                        the estimated refund from ${selectedBank ? selectedBank : ""
                            } for this overdraft
                        facility?`}
                        </h2>
                        <div className="ms-lg-5 ms-md-3 ms-0 ps-lg-4 ps-md-3 ps-sm-2 ps-0 pt-lg-2 pt-md-4 pt-sm-2 pt-2 below-text">
                          <div className="mt-2 d-flex align-items-center">
                            <div className="me-3">
                              <img height="25" src={pound} alt="" />
                            </div>

                            <div>
                              {" "}
                              Our Highest Overdraft Refund is -{" "}
                              <strong>£3,024</strong>
                            </div>
                          </div>
                          <div
                            className={`mt-3 d-flex align-items-center ${showRefundSection}`}
                          >
                            <div className="me-3">
                              <img height="25" src={pound} alt="" />
                            </div>
                            <div>
                              {" "}
                              Our Average Overdraft Refund is -{" "}
                              <strong> £993</strong>
                            </div>
                          </div>
                        </div>
                        <ul className="btn-option optinal-items  two-options    ">
                          <li>
                            <div className=" option_but" onClick={nextQuestion}>
                              <input
                                type="radio"
                                id="318"
                                value="318"
                                name="check1"
                              />
                              <label
                                for="318"
                                className=" align-items-center  btn-next"
                              >
                                <div> Yes</div>
                              </label>
                            </div>
                          </li>

                          <li>
                            <div
                              className=" option_but  btn-next"
                              onClick={nextQuestion}
                            >
                              <input
                                type="radio"
                                id="319"
                                name="check1"
                                value="319"
                              />
                              <label for="319" className=" ">
                                <div> No</div>
                              </label>
                            </div>
                          </li>
                        </ul>
                      </div>
                      <div
                        className={`swiper-slide slide-up-now ${state.questTwo}`}
                      >
                        <h2 className="qs-title  ">
                          Would you also like us to identify other unaffordable
                          lending opportunities?
                        </h2>
                        <div className="ms-lg-5 ms-md-3 ms-0 ps-lg-4 ps-md-3 ps-sm-2 ps-0 pt-lg-2 pt-md-4 pt-sm-2 pt-2 below-text">
                          <div className="mt-2 d-flex align-items-center"></div>
                          <div className={"mt-1 d-flex align-items-center"}>
                            <div className="me-3">
                              <img height="25" src={pound} alt="" />
                            </div>
                            <div>
                              {" "}
                              Our Average Refund for Unaffordable credit is
                              <strong> £2,200^</strong>
                            </div>
                          </div>
                        </div>
                        <ul className="btn-option optinal-items  two-options    ">
                          <li>
                            <div
                              className=" option_but "
                              onClick={nextQuestion}
                            >
                              <input
                                type="radio"
                                id="320"
                                value="320"
                                name="check2"
                              />
                              <label
                                for="320"
                                className=" align-items-center endQuest"
                              >
                                <div> Yes</div>
                              </label>
                            </div>
                          </li>

                          <li>
                            <div className="option_but" onClick={nextQuestion}>
                              <input
                                type="radio"
                                id="321"
                                name="check2"
                                value="321"
                              />
                              <label for="321" className="endQuest">
                                <div> No</div>
                              </label>
                            </div>
                          </li>
                        </ul>
                      </div>
                      <div
                        className={`swiper-slide slide-up-now ${state.questThree}`}
                      >
                        <h2 className="qs-title  ">
                          Would you also like a FREE mis-sold car finance
                          evaluation?
                        </h2>
                        <div className="ms-lg-5 ms-md-3 ms-0 ps-lg-4 ps-md-3 ps-sm-2 ps-0 pt-lg-2 pt-md-4 pt-sm-2 pt-2 below-text">
                          <div className="mt-2 d-flex align-items-center">
                            <div className="me-3">
                              <img height="25" src={pound} alt="" />
                            </div>

                            <div>
                              {" "}
                              Reclaim up to <strong>£3,300*</strong> for
                              Mis-Sold Car Finance
                            </div>
                          </div>
                        </div>
                        <ul className="btn-option optinal-items  two-options    ">
                          <li>
                            <div
                              className=" option_but "
                              onClick={nextQuestion}
                            >
                              <input
                                type="radio"
                                id="326"
                                value="326"
                                name="check3"
                              />
                              <label
                                for="326"
                                className=" align-items-center endQuest"
                              >
                                <div> Yes</div>
                              </label>
                            </div>
                          </li>

                          <li>
                            <div className="option_but" onClick={nextQuestion}>
                              <input
                                type="radio"
                                id="327"
                                name="check3"
                                value="327"
                              />
                              <label for="327" className="endQuest">
                                <div> No</div>
                              </label>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className=""></div>
                    <div className="mt-2 mb-4 text-center">
                      <div>
                        {" "}
                        <button
                          className="back-btn mainbckBtn bi bi-chevron-left"
                          type="button"
                          value={bacKbtnId}
                          onClick={prevQuestion}
                          disabled={btnDisable}
                        >
                          Back
                        </button>{" "}
                      </div>
                    </div>
                  </div>

                  <div className="mt-2 mb-3 justify-content-between  align-items-center text-center slide-up-now">
                    <div className="ms-auto d-flex justify-content-center g-2 pe-lg-3 pe-md-3 ps-sm-0 pe-0 mb-lg-0 mb-md-0 mb-sm-4  mb-4">
                      <div>
                        <img className="ps-2" height="28" src={ssl} alt="" />{" "}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="pt-lg-4 pt-md-5 pt-sm-3 pt-3">
                <div className="d-flex text-danger">
                  <div className="pe-2"></div>
                  <div>
                    <p className={` text-black ${questTwo}`}>
                      ^Our Average Refund for Vanquis as of 20/08/2024
                    </p>
                    <p className={` text-black ${questThree}`}>
                      *Estimate based on £1,100 overcharge per finance agreement
                      taken from the FCA's Motor Finance - Final Findings,
                      multiplied by our average agreements per Client.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};
export default CreditCheckQuestions_FLP_OD;
